module.exports = __webpack_public_path__ + "img/BD0D0D_970404_7B0404_550404-256px.dcbb0c00.png";